import React from "react";
import "./Services.css";

const services = [
  {
    title: "Website & Web App Development",
    description:
      "High-performance corporate websites, portals, dashboards, and custom business systems built using React, Node.js, Next.js, and Flutter Web.",
  },
  {
    title: "Mobile App Development",
    description:
      "Native-quality iOS and Android apps designed with Flutter for operations, customer platforms, internal tools, management systems, and real-time business workflows.",
  },
  {
    title: "Cloud Hosting & Infrastructure",
    description:
      "Scalable cloud solutions built on AWS including server deployment, microservices, API development, CI/CD pipelines, database architecture, and secure asset hosting.",
  },
  {
    title: "Custom Software Development",
    description:
      "Tailored enterprise systems including automation platforms, admin dashboards, internal tools, monitoring systems, workflows, and complete digital ecosystems.",
  },
  {
    title: "IoT Integrations",
    description:
      "Real-time hardware and software integration for monitoring, automation, analytics dashboards, device communication, and synchronized smart-device workflows.",
  },
  {
    title: "Digital Signage Systems",
    description:
      "Intelligent media scheduling, remote monitoring, and large-scale screen deployment systems refined through real-world digital signage operations.",
  },
];

const Services = () => {
  return (
    <div className="services-wrapper">
      <div className="services-container">
        <div className="services-header">
          <span className="services-eyebrow">Our capabilities</span>

          <h1 className="services-title">
            Services built for <span>performance</span>
          </h1>

          <p className="services-intro">
            Pryce Technologies delivers end-to-end digital solutions from custom
            software, mobile applications, and cloud infrastructure to IoT
            integrations and enterprise automation. Designed for reliability,
            scalability, and real-world business impact.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-card-top">
                <div className="service-icon-wrap">
                  <div className="service-icon-dot"></div>
                </div>
              </div>

              <h3>{service.title}</h3>
              <p>{service.description}</p>

              <div className="service-card-footer">
                <span className="service-link">Learn more</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;